import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorIdPorGestor(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/gestores/entregas/${entregaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorGestor(filtro) {
        return axiosJwt
            .get(
                `${api}/credenciados/gestores/entregas?status=${filtro.status}&situacao=${filtro.situacao}&prazo=${filtro.prazo}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarEntrega(aprovaReprovaEntregaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/aprovar`,
                aprovaReprovaEntregaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEntregaAnexo(entregaAnexoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/gestores/entregas/anexos/${entregaAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    pesquisarEvento(entregaId, codEvento) {
        return axiosJwt
            .get(
                `${api}/credenciados/gestores/entregas/${entregaId}/evento/${codEvento}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarEvento(entregaEvento) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${entregaEvento.entregaId}/evento/associar`,
                entregaEvento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarEventoEspecial(entregaEvento) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${entregaEvento.entregaId}/evento/aprovar`,
                entregaEvento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarEvento(entregaEvento) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${entregaEvento.entregaId}/evento/atualizar`,
                entregaEvento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarEntrega(entregaCancelada) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${entregaCancelada.entregaId}/cancelar`,
                entregaCancelada
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reabrirEntrega(entregaReaberta) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${entregaReaberta.entregaId}/reabrir`,
                entregaReaberta
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposCancelamento() {
        return axiosJwt
            .get(`${api}/credenciados/gestores/entregas/tiposcancelamento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarValorHora(entregaValorHoraAtualizadoDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${entregaValorHoraAtualizadoDto.entregaId}/atualizarvalorhora`,
                entregaValorHoraAtualizadoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDataPrevisao(entregaDataPrevisaoAtualizadaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${entregaDataPrevisaoAtualizadaDto.entregaId}/atualizardataprevisao`,
                entregaDataPrevisaoAtualizadaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarReabertura(solicitacaoReaberturaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/entregas/${solicitacaoReaberturaDto.entregaId}/solicitarreabertura`,
                solicitacaoReaberturaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/gestores/entregas/${entregaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/gestores/entregas/${entregaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
